import { PageMeta, PageRequest } from '@/app/core/models/paged-result.model';
import { PaymentOrder, PaymentOrderFilters, PaymentOrderPage } from '../models/payment-order.model';
import {
  PaymentOrderApiItem,
  PaymentOrderApiMeta,
  PaymentOrderApiResponse,
} from './payment-order-api.types';

export function toApiQueryParams(
  filters: PaymentOrderFilters,
  page: PageRequest,
): Record<string, string | number> {
  const params: Record<string, string | number> = { page: page.page, size: page.size };
  if (filters.startDate) params['startDate'] = filters.startDate;
  if (filters.endDate) params['endDate'] = filters.endDate;
  return params;
}

export function toPageMeta(meta: PaymentOrderApiMeta): PageMeta {
  return {
    page: meta.page,
    size: meta.limit,
    totalElements: meta.total,
    totalPages: Math.max(meta.totalPages, 1),
    hasNextPage: meta.hasNextPage,
    hasPrevPage: meta.hasPrevPage,
  };
}

export const toPaymentOrder = (item: PaymentOrderApiItem): PaymentOrder => ({
  documentNumber: item.documentNumber,
  documentType: item.documentType,
  netAmount: item.netAmount,
  netAmountRaw: item.netAmountRaw,
  opaNumber: item.opaNumber,
  paymentDate: item.paymentDate,
  paymentDateRaw: item.paymentDateRaw,
  paymentBranch: item.paymentBranch,
  status: item.status,
});

export const toPaymentOrderPage = (response: PaymentOrderApiResponse): PaymentOrderPage => ({
  content: response.data.map(toPaymentOrder),
  page: toPageMeta(response.meta),
});
